module.exports = __webpack_public_path__ + "img/placeholder.8067c440.svg";